import store from "../../../../../../../store";
import SqftJsonApi from "../../../../../api/sqftJsonApi";
import {CabinetsSet, CountertopPositions, WallPositions} from "../../../../../helpers/sqftCabinetsDataMapper";
import CabinetLoader from "./CabinetLoader";
import {SQFT_VIEW_MODE} from "../../../../../constants";

class SceneModelsLoader {
  constructor(sceneViewer, scene, modelScale) {
    this.sceneViewer = sceneViewer;
    this.scene = scene;
    this.modelScale = modelScale;
    this.loader = new window.GLTFLoader();
    this.cabinetLoader = new CabinetLoader(this.scene, this.modelScale, this.loader);
  }

  async loadAllModels() {
    const reduxState = store.getState();
    const {isMobile} = reduxState.serverState;
    const models = [
      () => this.loadCabinetSet(),
      () => this.loadCountertops(),
      () => this.loadWalls()
    ];

    // Load countertops only on desktop
    const isIosDevice = navigator && (/iPad|iPhone/.test(navigator.userAgent));
    if (!isMobile && !isIosDevice) {
      //models.push(() => this.loadCountertops())
    }

    // Load models one by one
    for (let i = 0; i < models.length; i++) {
      try {
        await models[i]();
      } catch (error) {
        console.error(`❌ Error loading ${i + 1}:`, error);
      }
    }

    this.sceneViewer.modelsLoaded = true;
  }

  async loadCabinetSet() {
    const reduxState = store.getState();
    const SQFTViewMode = reduxState.sqftState.SQFTViewMode;
    const should_display_framed_doors = SQFTViewMode === SQFT_VIEW_MODE.threeDModeFramed;
    const cabinetPositions = await CabinetsSet.prepareCabinetsPositions(should_display_framed_doors);
    let models = [];

    console.log("cabinetPositions", cabinetPositions);

    // Load cabinet models one by one
    for (let i = 0; i < cabinetPositions.length; i++) {
      try {
        const model = await this.cabinetLoader.loadModel(cabinetPositions[i]);
        if (model) models.push(model);
      } catch (error) {
        console.error(`❌ Error loading cabinet ${i + 1}:`, error);
      }

      //add light on first model loaded
      if (i === 0) {
        const totalBox = this.calculateModelsBox(models);
        this.sceneViewer.setModelsCenter(totalBox.getCenter(new window.THREE.Vector3()));
        this.sceneViewer.updateSceneLighting('addLightV10');
      }
    }

    //add light on first model loaded
    if (models.length > 0) {
      const totalBox = this.calculateModelsBox(models);
      this.sceneViewer.setModelsCenter(totalBox.getCenter(new window.THREE.Vector3()));
      this.sceneViewer.setModelsSize(totalBox.getSize(new window.THREE.Vector3()).length());
      this.sceneViewer.calculateAndSetCameraPosition(this.sceneViewer.modelsCenter, this.sceneViewer.modelsSize);
      this.sceneViewer.updateSceneLighting('addLightV10');
    }
  }

  async loadCountertops() {
    const countertopPositions = CountertopPositions.prepareCountertopPositions();

    console.log("countertopPositions", countertopPositions);
    const loader = this.loader;

    for (let i = 0; i < countertopPositions.length; i++) {
      const countertopPosition = countertopPositions[i];
      try {
        const countertop = await SqftJsonApi.getCountertops(countertopPosition, {});
        if (!countertop.s3Url) {
          console.log(`No URL for countertop at position: ${countertopPosition}`);
          continue;
        }

        await new Promise((resolve, reject) => {
          loader.load(
            countertop.s3Url,
            (gltf) => {
              gltf.scene.position.set(
                0,
                countertopPosition.y / this.modelScale,
                0
              );

              if (this.scene) {
                this.scene.add(gltf.scene);
              }
              resolve();
            },
            undefined,
            (error) => {
              console.error(`❌ Error loading model8: ${countertop.s3Url}`, error);
              reject(error);
            }
          );
        });

        await new Promise(resolve => setTimeout(resolve, 200));
      } catch (error) {
        console.error(`❌ Error loading countertop ${i + 1}:`, error);
      }
    }
  }

  loadWalls = async () => {
    const wallPositions = WallPositions.prepareWallPositions();
    const loader = this.loader;

    const wallPromises = wallPositions.map(async (wallPosition) => {
      try {
        const wall = await SqftJsonApi.getWall(wallPosition, {});
        //console.log("wallPosition", wallPosition);
        //console.log("wall", wall);
        if (wall.s3Url) {
          loader.load(wall.s3Url, (gltf) => { // Загружаем модель столешницы

            //v1 adjust model size to position in workspace
            gltf.scene.position.set(
              0,//wallPosition.x / this.modelScale,
              1 / this.modelScale ,//wallPosition.y / this.modelScale,
              0//wallPosition.z / this.modelScale
            );
            //console.log(`wall position: X=${wallPosition.x}, Y=${wallPosition.y}, Z=${wallPosition.z}`)
            //console.log("gltf.scene.position", gltf.scene.position);

            //v2
            //this.normalizeModelSizeFromConstantScale(gltf.scene);
            //gltf.scene.rotation.y = wallPosition.rotation;
            if (this.scene) {
              this.scene.add(gltf.scene);
            }
          }, undefined, (error) => {
            console.error(`Error loading wall model from URL ${wall.s3Url}:`, error);
          });
        } else {
          console.log(`No URL for wall at position: ${wallPosition}`);
        }
      } catch (error) {
        console.error(`Failed to get wall data for position ${wallPosition}`, error);
      }
    });

    return await Promise.all(wallPromises);
  }

  calculateModelsBox(models) {
    const totalBox = new window.THREE.Box3();
    models.forEach(model => {
      if (model instanceof window.THREE.Object3D) {
        totalBox.expandByObject(model);
      }
    });

    return totalBox
  }

  normalizeModelSize(model, targetLength) {
    const box = new window.THREE.Box3().setFromObject(model);
    const size = box.getSize(new window.THREE.Vector3());
    const currentLength = size.x;

    const scale = targetLength / currentLength;
    //console.log("scale", scale);
    model.scale.set(scale, scale, scale);
  }

  normalizeModelSizeFromConstantScale(model, ) {
    model.scale.set(this.modelScale, this.modelScale, this.modelScale);
  }
}

export default SceneModelsLoader;
